import axios from 'axios';
import { sessionService } from './session.service';

const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';

const api = axios.create({
  baseURL: apiUrl,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add session ID to all requests
api.interceptors.request.use(
  (config) => {
    const sessionId = sessionService.getSessionId();
    const metadata = sessionService.getMetadata();

    // Add session tracking headers
    config.headers['X-Session-ID'] = sessionId;
    config.headers['X-Session-User'] = metadata.userEmail || 'anonymous';
    config.headers['X-Session-Step'] = metadata.currentStep || 'unknown';

    // Increment event counter
    sessionService.incrementEventCount();

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Track response timing
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default api;
